"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rpc_utils_1 = require("rpc-utils");

var methods = {
  '3id_getLink': function id_getLink(ctx) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ctx.provider.wallet.getLink();

            case 2:
              return _context.abrupt("return", _context.sent.toLowerCase());

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  },
  '3id_linkManagementKey': function id_linkManagementKey(ctx) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ctx.provider.wallet.linkManagementKey();

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  },
  '3id_authenticate': function id_authenticate(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return ctx.provider.wallet.authenticate(params.spaces, {
                authData: params.authData,
                address: params.address,
                mgmtPub: params.mgmtPub
              }, ctx.origin);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  },
  '3id_isAuthenticated': function id_isAuthenticated(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return ctx.provider.wallet.isAuthenticated(params.spaces, ctx.origin);

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  },
  '3id_signClaim': function id_signClaim(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return ctx.provider.wallet.signClaim(params.payload, {
                DID: params.did,
                space: params.space,
                expiresIn: params.expiresIn,
                useMgmt: params.useMgmt
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  },
  '3id_encrypt': function id_encrypt(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return ctx.provider.wallet.encrypt(params.message, params.space, {
                blockSize: params.blockSize,
                to: params.to
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  },
  '3id_decrypt': function id_decrypt(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return ctx.provider.wallet.decrypt({
                ciphertext: params.ciphertext,
                ephemeralFrom: params.ephemeralFrom,
                nonce: params.nonce
              }, params.space, params.buffer);

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  },
  '3id_hashEntryKey': function id_hashEntryKey(ctx, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return ctx.provider.wallet.hashDBKey(params.key, params.space);

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
  },
  '3id_newAuthMethodPoll': function id_newAuthMethodPoll(ctx) {
    return ctx.provider.pollAuthMethods();
  },
  '3id_newLinkPoll': function id_newLinkPoll(ctx) {
    return ctx.provider.pollLinks();
  }
};

var ThreeIdProvider = /*#__PURE__*/function () {
  function ThreeIdProvider(wallet) {
    var _this = this;

    _classCallCheck(this, ThreeIdProvider);

    this._newAuthMethods = [];
    this._newLinks = [];
    this._handle = rpc_utils_1.createHandler(methods);
    this.wallet = wallet;
    wallet.events.on('new-auth-method', function (authBlob) {
      _this._newAuthMethods.push(authBlob);
    });
    wallet.events.on('new-link-proof', function (linkProof) {
      _this._newLinks.push(linkProof);
    });
  }

  _createClass(ThreeIdProvider, [{
    key: "is3idProvider",
    get: function get() {
      return true;
    }
  }, {
    key: "pollAuthMethods",
    value: function pollAuthMethods() {
      var methods = _toConsumableArray(this._newAuthMethods);

      this._newAuthMethods = [];
      return methods;
    }
  }, {
    key: "pollLinks",
    value: function pollLinks() {
      var links = _toConsumableArray(this._newLinks);

      this._newLinks = [];
      return links;
    }
  }, {
    key: "send",
    value: function send(req, origin, callback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var res, error;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (typeof origin === 'function') {
                  callback = origin;
                  origin = null;
                }

                _context9.next = 3;
                return this._handle({
                  provider: this,
                  origin: origin
                }, req);

              case 3:
                res = _context9.sent;

                if (!(res === null || res === void 0 ? void 0 : res.error)) {
                  _context9.next = 12;
                  break;
                }

                error = rpc_utils_1.RPCError.fromObject(res.error);

                if (!(callback == null)) {
                  _context9.next = 10;
                  break;
                }

                throw error;

              case 10:
                callback(error);
                return _context9.abrupt("return", null);

              case 12:
                callback === null || callback === void 0 ? void 0 : callback(null, res);
                return _context9.abrupt("return", res);

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }]);

  return ThreeIdProvider;
}();

exports.default = ThreeIdProvider;